import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getAllRegistrosByIdEstudianteIdIdiomaEstado } from "../../../services/registro.service";
import { getAllEstudiantes } from "../../../services/estudiante.service";
import { useSelector } from "react-redux";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";

export const RegistroEstudiantePage = () => {
  const { idIdioma } = useParams();
  const [registros, setRegistros] = useState({
    progreso: [],
    aprobado: [],
    reprobado: [],
    culminado: [],
  });
  const [selectedTab, setSelectedTab] = useState("progreso");
  const userName = useSelector((store) => store.usuario.username);
  useEffect(() => {
    getAllRegistros(idIdioma);
  }, [idIdioma, userName]);

  const getAllRegistros = async (idIdioma) => {
    try {
      // Usar estudianteId cacheado si existe para evitar búsqueda global
      const userInfo = JSON.parse(localStorage.getItem("userInfoES") || "{}");
      const cacheKey = `estudianteIdByUser_${userName || userInfo?.username || ""}`;
      let estudianteId = JSON.parse(localStorage.getItem(cacheKey) || "null");
      let estudiante = null;

      if (!estudianteId) {
        const estudiantesData = await getAllEstudiantes();
        estudiante = estudiantesData.find((est) => est.usuario.username === userName);
        if (estudiante?.estudiante?.idEstudiante) {
          estudianteId = estudiante.estudiante.idEstudiante;
          localStorage.setItem(cacheKey, JSON.stringify(estudianteId));
        }
      }
      if (estudianteId) {
        const estados = ["Progreso", "Aprobado", "Reprobado", "Culminado"];
        const [progreso, aprobado, reprobado, culminado] = await Promise.all(
          estados.map((estado) =>
            getAllRegistrosByIdEstudianteIdIdiomaEstado(
              estudianteId,
              idIdioma,
              estado
            )
          )
        );
        setRegistros({ progreso, aprobado, reprobado, culminado });
      } else {
        console.log("Estudiante no encontrado");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const renderRegistros = (registros) => (
    <section className="mx-auto px-4 py-8">
      {registros.length > 0 ? (
        <div className="grid grid-cols-[repeat(auto-fit,_300px)] max-w-[1000px] justify-between gap-6 mx-auto">
          {registros.map((registro) => (
            <div
              key={registro?.idRegistro}
              className="shadow-md rounded-lg p-6 flex flex-col mb-auto bg-white"
            >
              <h3 className="text-xl font-semibold text-theme-blue text-center mb-4">
                {registro?.grupo?.modulo?.nombre} | {registro?.grupo?.nombre}
              </h3>
              <div className="mb-4">
                <p className="font-semibold">
                  Docente:{" "}
                  <span className="font-normal truncate break-words whitespace-normal">
                    {registro?.grupo?.docente?.nombre} {registro?.grupo?.docente?.apellido}
                  </span>
                </p>
              </div>
              <div className="flex">
                <Link
                  to={`/modulos/${idIdioma}/detalles`}
                  state={{ registro }}
                  className=" bg-theme-yellow text-white font-semibold transition-colors hover:bg-yellow-500 py-1 px-4 rounded-sm shadow-md w-full text-center"
                >
                  Ver curso
                </Link>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-xl">
          No tienes módulos en este estado.
        </p>
      )}
    </section>
  );

  return (
    <ContenedorPageTemplate fondo={false}>

      <div className="flex justify-center flex-col mx-auto w-[1000px]">
        <h2 className="text-3xl font-bold text-start mb-4">Mis módulos</h2>
        <div className="flex justify-start  border-b border-slate-300 font-medium">
          <button
            className={`px-4 py-2 ${selectedTab === "progreso" ? "font-semibold border-b-[3px] border-theme-blue" : ""
              }`}
            onClick={() => setSelectedTab("progreso")}
          >
            En progreso
          </button>
          <button
            className={`px-4 py-2 ${selectedTab === "aprobado" ? "font-semibold border-b-[3px] border-theme-blue" : ""
              }`}
            onClick={() => setSelectedTab("aprobado")}
          >
            Aprobados
          </button>
          <button
            className={`px-4 py-2 ${selectedTab === "reprobado" ? "font-semibold border-b-[3px] border-theme-blue" : ""
              }`}
            onClick={() => setSelectedTab("reprobado")}
          >
            Reprobados
          </button>
        </div>

      </div>

      {selectedTab === "progreso" && renderRegistros(registros.progreso)}
      {selectedTab === "aprobado" && renderRegistros(registros.aprobado)}
      {selectedTab === "reprobado" && renderRegistros(registros.reprobado)}
      {selectedTab === "culminado" && renderRegistros(registros.culminado)}

    </ContenedorPageTemplate>
  );
};